import React from 'react';
import { Avatar, Stack, Typography } from '@mui/material';
import { PlannerEmployee } from 'pages/WorkSchedulesPlanner/interfaces';

interface EmployeeSummaryProps {
  employee: PlannerEmployee;
}

export default function EmployeeSummary({ employee }: EmployeeSummaryProps) {
  return (
    <Stack direction="row" alignItems="center" spacing={1.5}>
      <Avatar
        src={employee.avatarUrl}
        sx={{ width: '3.2rem', height: '3.2rem', position: 'static' }}
      />
      <Stack>
        <Typography variant="body2" fontWeight={700}>
          {employee.firstname} {employee.lastname}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {employee.position}
        </Typography>
      </Stack>
    </Stack>
  );
}
